import {
    Map,
    Marker,
    InfoWindow,
    GoogleApiWrapper,
    Polyline
} from "google-maps-react";

import React, { Component } from "react";
import Geocode from "react-geocode";
const containerStyle = {
    position: "relative",
    width: "calc(100% - 40px)",
    height: "calc(100% - 85px)",
    minHeight: 410
};

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            markerName: "",
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            coords: false,
            routes: false
        };
        Geocode.setApiKey(props.MapKey);
    }
    onMarkerChange = () => {
        const { coords } = this.state;

        Geocode.fromLatLng(coords).then(
            response => {
                const address = response.results[0].formatted_address;
                this.setState({ markerName: address });
            },
            error => {
                //  console.error(error);
            }
        );
    };
    onMarkerClick = (props, marker, e) => {
        this.onMarkerChange();
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    onMapClicked = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };
    apiIsLoaded = () => {
        if (this.props.waypoints) {
            let ways =
                this.props.waypoints.map(e => {
                    return {
                        location: { lat: e.latitude, lng: e.longitude },
                        stopover: false
                    };
                }) || [];
            const directionsService = new this.props.google.maps.DirectionsService();
            const directionsDisplay = new this.props.google.maps.DirectionsRenderer();
            directionsService.route(
                {
                    origin: {
                        lat: this.props.start.latitude,
                        lng: this.props.start.longitude
                    },
                    waypoints: ways,
                    destination: {
                        lat: this.props.end.latitude,
                        lng: this.props.end.longitude
                    },
                    travelMode: "DRIVING"
                },
                (response, status) => {
                    if (status === "OK") {
                        directionsDisplay.setDirections(response);
                        let routes = response.routes[0].overview_path.map(e => {
                            return {
                                lat: e.lat(),
                                lng: e.lng()
                            };
                        });
                        this.setState({ routes });
                    } else {
                        window.alert(
                            "Directions request failed due to " + status
                        );
                    }
                }
            );
        }
    };
    render() {
        const { start, end, style, zoom } = this.props;

        if (!start && !end) {
            console.error("map not loading");
            return null;
        } else {
            return (
                <Map
                    id="map"
                    style={style}
                    google={this.props.google}
                    initialCenter={{
                        lat: start.latitude,
                        lng: start.longitude
                    }}
                    zoom={zoom ? zoom : 16}
                    center={{ lat: start.latitude, lng: start.longitude }}
                    containerStyle={containerStyle}
                    onClick={(e, t, v) => {
                        this.onMapClicked();
                    }}
                    onReady={() => this.apiIsLoaded()}
                >
                    {start && (
                        <Marker
                            position={{
                                lat: start.latitude,
                                lng: start.longitude
                            }}
                            name={"Start Point"}
                            onClick={(props, marker, e) => {
                                this.setState({
                                    coord: {
                                        lat: start.latitude,
                                        lng: start.longitude
                                    }
                                });
                                this.onMarkerChange();
                                this.setState({
                                    selectedPlace: props,
                                    activeMarker: marker,
                                    showingInfoWindow: true
                                });
                            }}
                            onChange={this.onMarkerChange}
                            color={"green"}
                            icon={{
                                url: require("./imgs/start.png"),
                                anchor: new window.google.maps.Point(26, 26),
                                scaledSize: new window.google.maps.Size(26, 26)
                            }}
                        />
                    )}
                    {end && (
                        <Marker
                            position={{ lat: end.latitude, lng: end.longitude }}
                            name={"End Point"}
                            onClick={(props, marker, e) => {
                                this.setState({
                                    coord: {
                                        lat: end.latitude,
                                        lng: end.longitude
                                    }
                                });
                                this.onMarkerChange();
                                this.setState({
                                    selectedPlace: props,
                                    activeMarker: marker,
                                    showingInfoWindow: true
                                });
                            }}
                            onChange={this.onMarkerChange}
                            icon={{
                                url: require("./imgs/end.png"),
                                anchor: new window.google.maps.Point(26, 26),
                                scaledSize: new window.google.maps.Size(26, 26)
                            }}
                        />
                    )}
                    {this.props.waypoints &&
                        this.props.waypoints.map((e, i) => {
                            return (
                                <Marker
                                    key={i}
                                    position={{
                                        lat: e.latitude,
                                        lng: e.longitude
                                    }}
                                    name={"Way Point"}
                                    icon={{
                                        url: require("./imgs/way.png"),
                                        anchor: new window.google.maps.Point(
                                            26,
                                            26
                                        ),
                                        scaledSize: new window.google.maps.Size(
                                            26,
                                            26
                                        )
                                    }}
                                />
                            );
                        })}

                    <Polyline
                        path={
                            typeof this.state.routes === "object"
                                ? this.state.routes
                                : []
                        }
                        strokeColor="#0000FF"
                        strokeOpacity={0.8}
                        strokeWeight={4}
                    />

                    <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        <div>
                            <p>{this.state.markerName}</p>
                        </div>
                    </InfoWindow>
                </Map>
            );
        }
    }
}

export default GoogleApiWrapper(props => ({
    apiKey: props.mapKey
}))(MapContainer);
